import React from "react"
import styled from "styled-components"

const Footer: React.FC = () => (
	<Wrapper>
		Copyright © {new Date().getFullYear()} Sators.com Internet Solutions, Inc |{" "}
		<a href="/terms">Terms and Conditions</a> | <a href="/privacy">Privacy Policy</a>
	</Wrapper>
)

const Wrapper = styled.footer`
	margin: 40px;
	border-top: 1px solid rgb(214, 215, 216);
	padding: 20px;
	font-size: 14px;
`

export default Footer
